export { default as People } from './People';
export { default as Time } from './Time';
export { default as GirlOnSofa } from './GirlOnSofa';
